<template>
<span :class=div_classes>
  <input type="range"
  :min=minpos
  :max=maxpos
  :class="classes"
  :step="display_step"
  v-model=value
  :ref="name"
   />
   <div class="gauge" :style="{marginLeft: gaugeMarginLeft+'%'}" ref="gauge">
   <slot name="gauge" >
   </slot>
   </div>
</span>
</template>

<script>
export default {
  
    data () {
        return {
            value: "",
        }
    },
    created : function(){
        this.set_default_value()
    },
    props: {
        step : {
          type: [Number, String],
          default: 1
        },
        classes : {
          type: String,
          default: "slider"
        },
        min : {
          type: [Number, String],
          default: 0
        },
        max : {
          type: [Number, String],
          default: 100
        },
        default_value : [Number, String],
        div_classes : String,
        name : {
            type: [String],
            default: "heyas"
        },
        logmode : {
            type: [Boolean],
            default: false
        },
        
    },
    computed: {
        minpos : function(){
            if(this.logmode){
                return 0
            }
            return this.min
        },
        maxpos: function(){
            if(this.logmode){
                return 100
            }
            return this.max
        },
        display_step: function(){
            if(this.logmode){
                return 1
            }
            return this.step
        },
        gaugeMarginLeft : function(){
            return parseInt(this.position)
        },
        position: function(){
            let v = this.value
            
            let position = v;
            
            if(!this.logmode){
                let minp = this.minpos;
                let maxp = this.maxpos;
                position = ((parseFloat(v - minp) / parseFloat(maxp -minp))*100).toFixed(0);
            }
            return position
        }
        
    },
    watch: {
        default_value : function(){
            this.set_default_value()
        },
        value : function(){
            let v = this.value
                
            if(this.logmode){
                let position = v;
                let minp = this.minpos;
                let maxp = this.maxpos;

                let minv = Math.log(this.min);
                let maxv = Math.log(this.max);
                let scale = (maxv-minv) / (maxp-minp);
                v = Math.exp(minv + scale*(position-minp)).toFixed(2);
                
                v = v - (v % this.step)
                if(v < this.min){
                    v = this.min;
                }
            } 

            this.notify_position()
            this.$emit('input', v)
        },
    },
    methods: {
        notify_position : function(){
            

        },
        set_default_value : function(){
            if(this.logmode){
                
                let minp = this.minpos;
                let maxp = this.maxpos;
                let minv = Math.log(this.min);
                let maxv = Math.log(this.max);
                let scale = (maxv-minv) / (maxp-minp);

                let position = (Math.log(this.default_value) - minv)/scale
                this.value = position.toFixed(0)
                
            } else {
                this.value = this.default_value

            }
            this.notify_position()

        }
    },
    
}
</script>

<style scoped>


.gauge {
    text-align: left;
    height: 1.5em;
}

.gauge > * {
    margin-left: -1.5em;
    float: left;
    border: 1px dotted #666;
    text-align: center;
    padding: 3px 1em;
    white-space: nowrap;
    border-radius: 10px;
    font-weight: bold;
    background-color: rgba(255,255,255,0.3);
    font-size: 10pt;
}



.slider {
    -webkit-appearance: none;  /* Override default CSS styles */
    appearance: none;
    width: 100%; /* Full-width */
    height: 25px; /* Specified height */
    outline: none; /* Remove outline */
    
    border-radius: 10px;
    background: rgba(168, 171, 181, 0.55);
    
    border: 2px solid #fff;

}

.slider::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    width: 25px; /* Set a specific slider handle width */
    height: 25px; /* Slider handle height */
    background: #666; /* Green background */
    cursor: pointer; /* Cursor on hover */
        border-radius: 1em;

}

.slider::-moz-range-thumb {
    width: 25px; /* Set a specific slider handle width */
    height: 25px; /* Slider handle height */
    background: #666; /* Green background */
    cursor: pointer; /* Cursor on hover */
    border-radius: 1em;
}

</style>
